"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const LeftPanel_1 = __importDefault(require("./leftPanel/LeftPanel"));
const MainPanel_1 = __importDefault(require("./mainPanel/MainPanel"));
const RightPanel_1 = __importDefault(require("./rightPanel/RightPanel"));
const backgroundTasks_1 = require("../backgroundTasks");
const panels_1 = require("../domain/model/panels");
const viewMode_1 = require("../domain/model/viewMode");
const NotificationBar_1 = __importDefault(require("./NotificationBar"));
exports.default = App;
const useStyles = makeStyles_1.default((theme) => ({
    grid: {
        overflow: "hidden",
        backgroundColor: theme.colors.sidePanel.backgroundColor,
        flex: "1 0 auto",
    },
    left: {
        height: "100%",
        width: "40%",
        "&.rightPanelActive": {
            width: "30%"
        },
        "&.mobile": {
            width: "100%"
        }
    },
    main: {
        height: "100%",
        backgroundColor: theme.colors.mainPanel.backgroundColor,
        width: "60%",
        "&.rightPanelActive": {
            width: "40%"
        },
        "&.mobile": {
            width: "100%"
        }
    },
    right: {
        height: "100%",
        width: "30%",
        "&.mobile": {
            width: "100%"
        }
    },
    container: {
        height: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
    },
}));
function App() {
    const classes = useStyles();
    const panel = react_redux_1.useSelector((state) => state.appState.panelState);
    const viewMode = react_redux_1.useSelector((state) => state.appState.viewMode);
    const [gridHeight, setGridHeight] = react_1.useState("100%");
    backgroundTasks_1.setupBackgroundTasks();
    function buildLeftPanel() {
        if (panel.leftPanel === panels_1.LeftPanelType.None) {
            return null;
        }
        let className = classes.left;
        if (viewMode === viewMode_1.ViewMode.Mobile) {
            className += " mobile";
        }
        else if (panel.rightPanel !== panels_1.RightPanelType.None) {
            className += " rightPanelActive";
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Grid_1.default, { item: true, container: true, direction: "column", wrap: "nowrap", className: className },
                react_1.default.createElement(LeftPanel_1.default, { type: panel.leftPanel })),
            react_1.default.createElement(Divider_1.default, { orientation: "vertical", flexItem: true })));
    }
    function buildMainPanel() {
        if (panel.middlePanel === panels_1.MiddlePanelType.None) {
            return null;
        }
        let className = "main-panel " + classes.main;
        if (viewMode === viewMode_1.ViewMode.Mobile) {
            className += " mobile";
        }
        else if (panel.rightPanel !== panels_1.RightPanelType.None) {
            className += " rightPanelActive";
        }
        return (react_1.default.createElement(Grid_1.default, { item: true, container: true, direction: "column", className: className },
            react_1.default.createElement(MainPanel_1.default, null)));
    }
    function buildRightPanel() {
        if (panel.rightPanel === panels_1.RightPanelType.None) {
            return null;
        }
        let className = classes.right;
        if (viewMode === viewMode_1.ViewMode.Mobile) {
            className += " mobile";
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Divider_1.default, { orientation: "vertical", flexItem: true }),
            react_1.default.createElement(Grid_1.default, { item: true, container: true, direction: "column", wrap: "nowrap", className: className },
                react_1.default.createElement(RightPanel_1.default, { type: panel.rightPanel }))));
    }
    function onNotificationBarRender(render) {
        return render
            ? setGridHeight("calc(100% - 32px)")
            : setGridHeight("100%");
    }
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(NotificationBar_1.default, { onRender: onNotificationBarRender }),
        react_1.default.createElement(Grid_1.default, { container: true, wrap: "nowrap", className: classes.grid, height: gridHeight },
            buildLeftPanel(),
            buildMainPanel(),
            buildRightPanel())));
}
